export var PersonaCategory = /*#__PURE__*/function (PersonaCategory) {
  /**
   * Personas with different devices
   */
  PersonaCategory[PersonaCategory["DEVICES"] = 1] = "DEVICES";
  /**
   * Personas that has something to do with pregnancy
   */
  PersonaCategory[PersonaCategory["PREGNANCY"] = 2] = "PREGNANCY";
  /**
   * Personas for demo purposes
   */
  PersonaCategory[PersonaCategory["DEMO"] = 3] = "DEMO";
  /**
   * Personas with different subscriptions
   */
  PersonaCategory[PersonaCategory["SUBSCRIPTION"] = 4] = "SUBSCRIPTION";
  /**
   * Other
   */
  PersonaCategory[PersonaCategory["OTHER"] = 5] = "OTHER";
  return PersonaCategory;
}(PersonaCategory || {});